<app-offcanvas-base
  [returnUrl]="returnUrl"
  [closeBtnDisabled]="contactSyncClicked()">
  <ng-container outOfTemplateContent>
    @if (showReceipt) {
      @if (this.receiptFileCount() > 0) {
        <app-receipt-carousel
          [receipts]="transactionDetail().receipt_files ?? []"
          [initialSlide]="activeSlideIndex"
          (swiperReady)="onCarouselSwiperReady($event)"
          (slideChanged)="onCarouselSlideChanged($event)"
          (closePreview)="onCloseReceiptCarouselPreview($event)">
        </app-receipt-carousel>
      } @else if (transactionDetail().receipt) {
        <app-receipt-preview
          [receiptUrl]="transactionDetail().receipt!"
          (closePreview)="showReceipt = false">
        </app-receipt-preview>
      }
    }
  </ng-container>

  <ng-container title>
    @if (!splitItems().length && !splitTransaction()) {
      Edit
    } @else {
      {{ splitEditMode() ? 'Edit' : 'View' }}
    }
    transaction details
  </ng-container>
  <ng-container headerExtra>
    @if (!isNonEditableStatus() && !statusReady()) {
      <div
        class="ms-auto flag-container"
        [ngClass]="{ 'flagged': isFlagged() }"
        headerExtra>
        <div class="row align-items-center gx-1">
          <div
            class="col text-nowrap"
            [ngClass]="{ 'text-danger': isFlagged() }">
            <i class="iconoir-dash-flag"></i>&nbsp;{{ isFlagged() ? 'Flagged' : 'Flag' }}
          </div>
          <div class="col">
            <app-toggle-switch
              [hideIcon]="true"
              [class]="isFlagged() ? 'danger' : ''"
              [hideLabel]="true"
              [initialValue]="isFlagged()"
              [label]="'Flag'"
              [id]="'flagToggle'"
              iconClass=""
              (switchChange)="updateFlag($event)">
            </app-toggle-switch>
          </div>
        </div>
      </div>
    }
  </ng-container>
  <ng-container body>
    @if (form) {
      <form
        [formGroup]="form"
        [boFormOptions]="options"
        (ngSubmit)="onSubmit()">
        @if (!isLoading() && transactionDetail()) {
          <div class="mt-neg-3"></div>
          <div class="flag-btn-position"></div>
          <button
            type="button"
            #toggleDetailsBtnContainer
            class="row align-items-center btn-reset mb-2 inline-collapse"
            (click)="onOpenTransactionDetails()"
            [ngClass]="{ 'collapsed': isTransactionDetailsCollapsed }">
            <div class="col-auto pe-0">
              <i class="iconoir-list text-secondary-2"></i>
            </div>
            <div class="col-auto">Transaction details</div>
            <div class="col-auto">
              <app-status-badge
                [value]="transactionDetail().status"
                [department]="statusBadgeDepartments.TRANSACTIONS">
              </app-status-badge>
            </div>
            <div class="col-auto ms-auto">
              <div class="collapse-arrow">
                <i class="iconoir-nav-arrow-right"></i>
              </div>
            </div>
          </button>
          <div
            #transactionDetails="ngbCollapse"
            [(ngbCollapse)]="isTransactionDetailsCollapsed">
            <div class="card border-secondary mb-3">
              <div class="card-body p-2">
                @if (hasAccounting() && hasActiveConnection()) {
                  <!-- CONTACT -->
                  <div class="p-2 pb-0 mb-2">
                    <div class="form-label">
                      {{ accountingService.provider() }} contact
                      <i
                        class="iconoir-info-circle text-muted ms-2"
                        [ngbTooltip]="tipContentContact"
                        tooltipClass="custom-tooltip"></i>
                      <ng-template #tipContentContact>
                        Your choice here will automatically apply to all unsynced and future transactions from this
                        merchant.
                      </ng-template>
                    </div>
                    <app-accounting-contacts-select
                      [disabled]="isNonEditableStatus()"
                      [selectedContact]="selectedContact"
                      [errorMessage]="showContactError"
                      (busySyncingButtonTrue)="contactBusySyncing($event)"
                      (selectionChanged)="onContactChange($event)"></app-accounting-contacts-select>
                    @if (showContactError) {
                      <div class="invalid-feedback d-block">
                        {{ showContactError }}
                      </div>
                    }
                  </div>
                }
                <!-- STATIC DETAILS -->
                <div class="row row-cols-1 row-cols-sm-2 gy-0">
                  <div class="col">
                    <app-info-block
                      label="Merchant"
                      [value]="transactionDetail().merchant">
                    </app-info-block>
                  </div>
                  <div class="col">
                    <app-info-block
                      label="Card holder"
                      [value]="
                        transactionDetail().card?.holder?.first_name + ' ' + transactionDetail().card?.holder?.last_name
                      ">
                    </app-info-block>
                  </div>
                  <div class="col">
                    <app-info-block
                      label="Amount"
                      [value]="transactionDetail().amount | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator">
                    </app-info-block>
                  </div>
                  <div class="col">
                    <app-info-block
                      label="Date"
                      [value]="transactionDetail().timestamp | date: 'dd MMM yyyy, hh:mm a'">
                    </app-info-block>
                  </div>
                </div>

                <hr class="my-2" />

                <div class="px-2">
                  <app-form-field
                    boFieldPath="description"
                    label="Transaction description"
                    [readonly]="isNonEditableStatus()"
                    placeholder="Enter what the expense was for"></app-form-field>

                  @if (!splitItems().length && !splitTransaction()) {
                    <!-- QUANTITY FIELDS -->
                    <!--
                              <div class="row">
                                <div class="col-8">
                                  <div (focusin)="onUnitPriceFocus()">
                                    <app-form-field
                                      [readonly]="isNonEditableStatus()"
                                      [addCurrencyMask]="true"
                                      [currencyMaskOptions]="maskConfig"
                                      boFieldPath="unit_price"></app-form-field>
                                  </div>
                                </div>
                                <div class="col-4">
                                  <app-form-field
                                    label="Qty"
                                    [readonly]="isNonEditableStatus()"
                                    boFieldPath="unit_quantity"></app-form-field>
                                </div>
                              </div>
                              -->

                    <!-- REGULAR CATEGORY -->
                    <div class="row gy-2 row-cols-2 mb-2">
                      <div class="col">
                        <div class="form-label">Category</div>
                        <app-select-transaction-category
                          [selectedCategoryId]="selectedCategoryId"
                          [readonly]="isNonEditableStatus()"
                          [errorMessage]="showCatError"
                          [showHiddenCategories]="false"
                          [placeholder]="'Search a category'"
                          [clearable]="false"
                          [searchable]="true"
                          (categoryChange)="onCategoryChange($event)"
                          (categorySyncError)="onCategorySyncError($event)">
                        </app-select-transaction-category>
                        @if (showCatError) {
                          <div class="invalid-feedback d-block">
                            {{ showCatError }}
                          </div>
                        }
                      </div>
                      <div class="col">
                        @if (hasActiveConnection() && provider() === AccountingProviderCompany.XERO) {
                          <div class="form-label">Tax type</div>
                          <app-tax-rate-select
                            [disabled]="isNonEditableStatus()"
                            [preferredTaxRateId]="categoryPreferredTaxRate()"
                            [selectedTaxRate]="transactionDetail().tax"
                            (selectedTaxRateChange)="onTaxRateChange($event)"></app-tax-rate-select>
                        } @else {
                          <app-select-field
                            boFieldPath="vat"
                            label="VAT type"
                            [options]="vatOptions"
                            [readonly]="isNonEditableStatus()"
                            [clearable]="false"
                            [searchable]="false"
                            placeholder="Select VAT"
                            [closeOnSelect]="true"></app-select-field>
                        }
                      </div>
                      @if (trackingCategories().length > 0) {
                        <div class="{{ trackingCategories().length > 1 ? 'col-12' : 'col' }}">
                          <div class="form-label">Tracking categories</div>
                          <app-tracking-categories
                            [disabled]="isNonEditableStatus()"
                            [selectedTrackingCats]="initialSavedTrackingCatIds()"
                            (selectedTrackingCatsChange)="getTrackingCats($event)"></app-tracking-categories>
                        </div>
                      }
                    </div>
                    @if (hasAccounting() && hasActiveConnection() && showCatSyncError() && selectedCategoryId) {
                      <div class="row align-items-center mb-3">
                        <div class="col-auto pe-0">
                          <div class="warning-icon">
                            <i class="iconoir-warning-circle"></i>
                          </div>
                        </div>
                        <div class="col">
                          To enable syncing this transaction, please select a category that was imported from your
                          accounting software.
                        </div>
                      </div>
                    }
                  }

                  <app-form-field
                    boFieldPath="invoice_number"
                    label="Invoice number (Optional)"
                    [readonly]="isNonEditableStatus()"
                    placeholder="Enter receipt/invoice number"></app-form-field>

                  @if (hasAccounting() && !statusSynched() && !splitEditMode()) {
                    <div class="pb-2">
                      <!-- TO MARK AS READY  / UNREADY STATE -->
                      @if (statusNew() || statusReady()) {
                        <div class="row align-items-center gy-2">
                          <div class="col-12">
                            <div class="form-label">Synchronise</div>
                            <app-toggle-label-switch
                              [initialValue]="statusReady()"
                              [label]="statusReady() ? 'Ready to sync' : 'Mark ready'"
                              [id]="transactionDetail().id"
                              (switchChange)="$event ? onToggleTransactionReady() : onToggleTransactionUnready()"
                              [disabled]="markReadyButtonDisabled()">
                            </app-toggle-label-switch>
                          </div>
                          <div class="col">
                            <!-- help text -->
                            @if (this.showContactErrorOnReady()) {
                              <div class="row text-sm text-muted align-items-center">
                                <div class="col-auto pe-0">
                                  <i class="iconoir-warning-circle text-danger"></i>
                                </div>
                                <div class="col">Untoggle ready status in order to select a contact</div>
                              </div>
                            }
                            @if (markReadyButtonDisabled()) {
                              <div class="row text-sm text-muted align-items-center">
                                <div class="col-auto pe-0">
                                  <i class="iconoir-warning-circle text-warning"></i>
                                </div>
                                <div class="col">
                                  @if (showUnsavedChanges()) {
                                    Unsaved changes <br />
                                  }
                                  @if (!splitItems().length && !selectedCategoryId) {
                                    Select a category or split transaction <br />
                                  }
                                  @if (selectedCategoryId && !selectedCategoryHasAccount && hasActiveConnection()) {
                                    Select a supported category <br />
                                  }
                                  @if (!hasActiveConnection()) {
                                    Accounting software connection is not active <br />
                                  }
                                  @if (!selectedContact.name && hasActiveConnection()) {
                                    Select a contact <br />
                                  }
                                  @if (!selectedTaxRateId && selectedCategoryId && hasActiveConnection()) {
                                    Select a tax type <br />
                                  }
                                  @if (isFlagged() && hasActiveConnection()) {
                                    Clear the flag before marking as ready <br />
                                  }
                                </div>
                              </div>
                            }
                            @if (latestTransactionSaved && statusNew()) {
                              <div class="row text-sm text-muted">
                                <div class="col-auto pe-0">
                                  <i class="iconoir-check-circle text-success"></i>
                                </div>
                                <div class="col">Changes have been saved</div>
                              </div>
                            }
                          </div>
                        </div>
                      }
                      @if (statusError()) {
                        <div class="alert alert-danger mb-2 mt-2">
                          <div class="row align-items-center">
                            <div class="col-auto pe-0">
                              <i class="iconoir-warning-circle"></i>
                            </div>
                            <div class="col small">
                              @if (syncAuthError) {
                                An authentication error occurred with your {{ provider() }} connection. Please reconnect
                                your account in the
                                <a
                                  routerLink="/accounting/integrations"
                                  class="text-danger-dark">
                                  integration settings.
                                </a>
                              } @else {
                                <div class="fw-semibold">
                                  @if (transactionProviderError) {
                                    {{ transactionProviderError }}
                                  } @else {
                                    An error occurred with the last syncing request. Please try again.
                                  }
                                </div>
                                To resolve this, clear the errors to enable editing the transaction details.
                              }
                            </div>
                          </div>
                        </div>
                        <button
                          type="button"
                          (click)="onToggleTransactionUnready()"
                          class="btn btn-outline-danger"
                          title="Clear errors">
                          Clear errors
                        </button>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- RECEIPT -->
          <button
            type="button"
            #toggleReceiptsBtnContainer
            class="row align-items-center btn-reset mb-2 inline-collapse"
            (click)="onOpenTransactionReceipts()"
            [ngClass]="{ 'collapsed': isTransactionReceiptsCollapsed }">
            <div class="col-auto pe-0">
              <i class="iconoir-list text-secondary-2"></i>
            </div>

            <div class="col-auto">
              @if (receiptFileCount()) {
                Receipt{{ receiptFileCount() > 1 ? 's' : '' }}
                <div
                  class="badge larger bg-gray text-body ms-1"
                  ngbTooltip="Maximum number of receipts reached"
                  [disableTooltip]="receiptFileCount() < 10">
                  {{ receiptFileCount() }}
                  <i class="iconoir-attachment"></i>
                </div>
              } @else {
                Receipt
              }
            </div>
            <div class="col-auto ms-auto">
              <div class="collapse-arrow">
                <i class="iconoir-nav-arrow-right"></i>
              </div>
            </div>
          </button>
          <div
            #transactionReceipts="ngbCollapse"
            [(ngbCollapse)]="isTransactionReceiptsCollapsed">
            <div class="card border-secondary mb-3">
              <div class="card-body p-2 pb-0">
                @if (isNonEditableStatus()) {
                  @if (!receiptFileCount() && !Boolean(transactionDetail().receipt)) {
                    <p class="mb-2"><em class="text-muted">No receipt was added for this transaction</em></p>
                  }
                }

                @if (Boolean(transactionDetail().receipt) && !switchToReceiptFileUpload()) {
                  <!-- OLD RECEIPT PREVIEW -->
                  <app-file-uploaded-type-display
                    [url]="transactionDetail().receipt ?? ''"
                    [hideDelete]="Boolean(isNonEditableStatus() || (splitEditMode() && splitItems().length))"
                    (uploadNewReceipt)="uploadNewReceipt()"
                    (viewReceipt)="onViewReceipt()"></app-file-uploaded-type-display>
                } @else {
                  <!-- UPLOAD -->
                  @if (!splitEditMode()) {
                    @if (!isNonEditableStatus()) {
                      <app-receipt-upload
                        [transactionId]="Number(transactionId)"
                        [textExtra]="'PDF, JPG, PNG (Max 10MB). Max limit of 10 receipts.'"
                        (batchUploadComplete)="onBatchUploadComplete($event)">
                      </app-receipt-upload>
                    }
                  } @else {
                    <p class="mb-2">
                      <em class="text-muted">Receipts cannot be added while editing split transactions</em>
                    </p>
                  }
                  <!-- PREVIEW -->
                  @if (receiptFileCount() > 0) {
                    <div [ngClass]="{ 'mt-2': receiptFileCount() < 10 && !isNonEditableStatus() }">
                      @for (receipt of transactionDetail().receipt_files; track receipt.id; let i = $index) {
                        <app-receipt-preview-box
                          [receipt]="receipt"
                          [receiptIndex]="i"
                          [isActive]="i === activeSlideIndex"
                          [swiperInstance]="carouselSwiper"
                          [hideDelete]="Boolean(isNonEditableStatus() || (splitEditMode() && splitItems().length))"
                          (receiptDeleted)="onReceiptDeleted($event)"
                          (viewReceipt)="onViewReceiptFile($event)"></app-receipt-preview-box>
                      }
                    </div>
                  }
                }
              </div>
            </div>
          </div>

          @if (nonFieldErrors?.length) {
            @for (error of nonFieldErrors; track error) {
              <div class="alert alert-danger">
                {{ error }}
              </div>
            }
          }
          <!--- IF NOT SPLIT MODE -->
          @if (!splitItems().length && !splitTransaction()) {
            <!-- CREATE SPLIT -->
            @if (!isNonEditableStatus()) {
              <hr class="my-2" />
              <div class="row align-items-center">
                <div class="col">
                  Itemise your Transaction
                  <i
                    class="iconoir-info-circle"
                    placement="top"
                    ngbTooltip="Split this transaction into smaller parts. Ideal for when a single bill contains items that belong to different budget categories."></i>
                </div>
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-reset text-secondary"
                    (click)="onSplitTransaction()">
                    Split transaction
                  </button>
                </div>
              </div>
            }
          } @else {
            <!-- IF SPLIT MODE -->
            @if (!splitEditMode()) {
              <!-- EXISTING SPLIT -->
              <div class="row align-items-center mb-2 flex-nowrap">
                <div class="col-auto align-self-baseline pe-0">
                  <i class="pays-svg-icon ic-split text-secondary-2"></i>
                </div>
                <div class="col lead">Split transaction details</div>
              </div>
              <app-transaction-split-categories-view
                [savedItems]="savedSplitItems"></app-transaction-split-categories-view>
            }
            <!-- CREATE SPLIT TRANSACTION -->
            @if (splitTransaction()) {
              <hr class="mt-0" />
              <div class="row align-items-center mb-3 flex-nowrap">
                <div class="col-auto align-self-baseline pe-0">
                  <i class="pays-svg-icon ic-split text-secondary-2"></i>
                </div>
                <div class="col lead">Split transaction</div>
                <div class="col-auto">
                  <div class="row flex-nowrap align-items-center gx-1">
                    <div class="col-auto">Remaining total:</div>
                    <div
                      class="col-auto lead fw-semibold"
                      [class.text-danger]="remainingTotal() < 0">
                      {{ remainingTotal() | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
                    </div>
                    @if (remainingTotal() === 0) {
                      <div class="col-auto">
                        <i class="iconoir-check-circle text-success"></i>
                      </div>
                    } @else {
                      <div class="col-auto">
                        @if (remainingTotal() < 0) {
                          <i
                            ngbTooltip="The total of the transaction line items cannot exceed the transaction amount."
                            placement="top-right"
                            class="iconoir-info-circle text-danger"></i>
                        } @else if (remainingTotal() > 0) {
                          <i
                            ngbTooltip="This is the remaining total that still needs to be allocated."
                            placement="top-right"
                            class="iconoir-info-circle"></i>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <!-- SPLIT CATEGORY BOXES -->
              <app-transaction-split-categories-edit
                [splitCategories]="splitCategories"
                [itemsErrors]="showItemsError"
                [savedItems]="savedSplitItems"
                [editMode]="splitEditMode()"
                (splitItemsChange)="onSplitItemsChange($event)"
                (categoryDeleted)="onCategoryDeleted($event)"
                (clearAllErrors)="onClearAllErrors()">
              </app-transaction-split-categories-edit>
              <!-- EMPTY STATE -->
              @if (!splitCategories.length) {
                <div class="text-center my-4">
                  <img
                    ngSrc="../../../../../../assets/graphics/split_transaction.svg"
                    alt="Split Transactions"
                    width="145"
                    height="119" />
                </div>
                <p class="text-muted text-sm text-center">
                  Add categories to split this transaction into smaller parts.
                </p>
              }
              @if (showSingleItemError && splitItems().length === 1) {
                <div class="alert alert-danger">
                  {{ showSingleItemError }}
                </div>
              }
              <div class="row justify-content-center mb-3">
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-outline-dark px-5 btn-sm"
                    (click)="addSplitCategory()">
                    <i class="iconoir-plus-circle me-2"></i> Add category
                  </button>
                </div>
              </div>
            }
          }
        } @else {
          <app-loader></app-loader>
        }

        <div class="row gy-3 offcanvas-buttons">
          @if (!splitItems().length && !splitTransaction()) {
            <!-- REGULAR CATEGORY -->
            <div class="col-12 col-sm-auto">
              <app-offcanvas-cancel-btn
                [returnUrl]="returnUrl"
                [isDisabled]="contactSyncClicked()"
                [btnText]="latestTransactionSaved ? 'Close' : 'Cancel'"></app-offcanvas-cancel-btn>
            </div>
            @if (!this.isNonEditableStatus()) {
              <div class="col-12 col-sm-auto ms-sm-auto">
                <app-submit
                  btnID="saveMainTransactionBtn"
                  [icon]="false"
                  [busy]="busy"
                  [disabled]="regularSaveDisabled()"
                  label="Save"></app-submit>
              </div>
            }
          } @else {
            <!-- SPLIT MODE -->
            @if (splitEditMode() && savedSplitItems.length > 0) {
              <div class="col-12 col-sm-auto">
                <button
                  id="cancelEditBtn"
                  class="btn btn-outline-dark"
                  (click)="onCancelEdit()"
                  type="button">
                  Cancel
                </button>
              </div>
            }

            @if (splitEditMode()) {
              <div class="col-12 col-sm-auto">
                <button
                  id="splitTransactionCancelBtn"
                  type="button"
                  (click)="onCancelSplitTransaction()"
                  class="btn btn-outline-danger">
                  {{ savedSplitItems.length && splitCategories.length ? 'Clear all' : 'Remove split' }}
                </button>
              </div>
            }

            @if (!this.isNonEditableStatus()) {
              @if (!splitEditMode()) {
                <div class="col-12 col-sm-auto">
                  <app-offcanvas-cancel-btn
                    [returnUrl]="returnUrl"
                    [isDisabled]="contactSyncClicked()"
                    [btnText]="latestTransactionSaved ? 'Close' : 'Cancel'"></app-offcanvas-cancel-btn>
                </div>
              }
              <div class="col-12 col-sm-auto ms-sm-auto">
                @if (splitEditMode() || fieldHasChanged) {
                  <app-submit
                    btnID="saveSplitTransactionBtn"
                    [icon]="false"
                    [busy]="busy"
                    [disabled]="splitSaveDisabled()"
                    label="Save"></app-submit>
                } @else {
                  <button
                    id="editSplitItemsBtn"
                    class="btn btn-primary"
                    (click)="onEditSplitItems()"
                    type="button">
                    Edit
                  </button>
                }
              </div>
            } @else {
              <div class="col-12 col-sm-auto">
                <app-offcanvas-cancel-btn
                  [returnUrl]="returnUrl"
                  [isDisabled]="contactSyncClicked()"></app-offcanvas-cancel-btn>
              </div>
            }
          }

          @if (!hasAccounting() && statusReady()) {
            <div class="col-12 col-sm-auto ms-auto">
              <button
                type="button"
                class="btn btn-primary"
                (click)="onToggleTransactionUnready()">
                Revert status
              </button>
            </div>
          }
        </div>
      </form>
    } @else {
      <app-loader
        class="my-4"
        errorItem="topup rule">
      </app-loader>
    }
  </ng-container>
</app-offcanvas-base>
